const preorderFieldValidation = () => {
    const fieldWrapper = document.querySelector('[data-preorder-field]');
    if (!fieldWrapper) return;
    const input = fieldWrapper.querySelector('input');
    const addToCartButton = document.querySelector('.preorder');
    const errorMessage = fieldWrapper.querySelector('[data-preorder-message]');
    const usedNumbers = fieldWrapper.dataset.numbersArray.split(', ');
    const minValue = fieldWrapper.dataset.minValue;
    const maxValue = fieldWrapper.dataset.maxValue;
    const usedPopupValues = document.querySelectorAll('[data-properties-value]');

    input.value = '';
    fieldWrapper.classList.remove('field-valid');
    fieldWrapper.classList.remove('field-invalid');
    usedPopupValues.forEach(value => {
        usedNumbers.push(value.innerText);
    })

    input.addEventListener('input', (event) => {
        let formattedValue = parseInt(event.target.value, 10);
        if (formattedValue > 0) {
            event.target.value = String(formattedValue).padStart(4, '0');
        }
        if (!usedNumbers.includes(event.target.value) && parseInt(event.target.value) <= parseInt(maxValue) && parseInt(event.target.value) > parseInt(minValue)) {
            errorMessage.innerHTML = '';
            addToCartButton.disabled = false;
            fieldWrapper.classList.add('field-valid');
            fieldWrapper.classList.remove('field-invalid');
        } else {
            if (usedNumbers.includes(event.target.value)) {
                errorMessage.innerHTML = errorMessage.dataset.messageUnavailable;
                addToCartButton.disabled = true;
                fieldWrapper.classList.remove('field-valid');
                fieldWrapper.classList.add('field-invalid');
            } else {
                errorMessage.innerHTML = errorMessage.dataset.messageInvalid;
                addToCartButton.disabled = true;
                fieldWrapper.classList.remove('field-valid');
                fieldWrapper.classList.add('field-invalid');
            }
        }
        if (!event.target.value) {
            addToCartButton.disabled = false;
            errorMessage.innerHTML = '';
        }
    })
}

const appFieldValidation = () => {
    const engravingInput = document.querySelector('[name="properties[Add your engraving text]"]');
    if(!engravingInput) return;

    engravingInput.addEventListener('input', (e) => {
        let value = e.target.value;

        value = value.toUpperCase();
        value = value.replace(/[^A-Z\s]/g, '');
        e.target.value = value;
    });
}

const additionalCheckoutValidation = () => {
    const checkoutButton = document.querySelector('button[name="checkout"]');
    const validatedProps =  document.querySelectorAll('[data-serial-numbers]');
    const validationMessage = document.querySelector('.validation__message');

    if (validatedProps.length === 0) return;

    validationMessage.classList.remove('show');
    checkoutButton.addEventListener('click', (event) => {
        event.preventDefault();
        let includedValues = false;
        let number;

        for (const validatedProp of validatedProps ) {
            const propsArray = validatedProp.dataset.serialNumbers;
            const value = validatedProp.querySelector('[data-properties-value]');
            if (propsArray.includes(value.innerHTML)) {
                includedValues = true;
                number = value.innerHTML;
            }
        }

        if (!includedValues) {
            window.location.href = '/checkout';
        } else {
            validationMessage.classList.add('show');
            validationMessage.querySelector('span').innerHTML = number;
        }
    })
}

const watchesReviewsSlider = () => {
    const track = document.querySelector('[data-watches-reviews-track]');
    if (!track || track.dataset.sliderReady) return;

    const originals = Array.from(track.children);
    if (originals.length < 2) return;

    track.dataset.sliderReady = 'true';
    originals.forEach((card) => track.appendChild(card.cloneNode(true)));

    let index = 0;
    let timer;
    let hovering = false;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const cardStep = () => {
        const card = track.children[0];
        if (!card) return 0;
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return card.getBoundingClientRect().width + gap;
    };

    const goTo = (nextIndex, instant = false) => {
        index = nextIndex;
        track.style.transition = instant ? 'none' : 'transform 0.7s ease';
        track.style.transform = `translateX(-${cardStep() * index}px)`;
    };

    const advance = () => {
        if (hovering || document.hidden) return;
        goTo(index + 1);
        if (index >= originals.length) {
            window.setTimeout(() => goTo(0, true), 720);
        }
    };

    const start = () => {
        window.clearInterval(timer);
        if (reduceMotion) return;
        timer = window.setInterval(advance, 4000);
    };

    track.addEventListener('transitionend', () => {
        if (index >= originals.length) goTo(0, true);
    });

    const viewport = track.closest('.watches-reviews__viewport');
    if (viewport) {
        viewport.addEventListener('mouseenter', () => {
            hovering = true;
            window.clearInterval(timer);
        });
        viewport.addEventListener('mouseleave', () => {
            hovering = false;
            start();
        });
    }

    window.addEventListener('resize', () => goTo(index % originals.length, true));
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) window.clearInterval(timer);
        else start();
    });

    goTo(0, true);
    start();
};

const releaseGalleryWheelScroll = () => {
    const gallery = document.querySelector('.watches-pdp .product-gallery');
    if (!gallery || gallery.dataset.wheelFix) return;
    gallery.dataset.wheelFix = 'true';

    gallery.querySelectorAll('.product-gallery__thumbnail-scroller').forEach((el) => {
        el.addEventListener('wheel', (event) => {
            if (event.ctrlKey || event.metaKey) return;
            if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) return;
            event.preventDefault();
            window.scrollBy(0, event.deltaY);
        }, { passive: false });
    });
};

const setupThumbnailSliderFade = () => {
    const list = document.querySelector('.watches-pdp .product-gallery__thumbnail-list');
    const scroller = list?.querySelector('.product-gallery__thumbnail-scroller');
    if (!list || !scroller || scroller.dataset.fadeReady) return;
    scroller.dataset.fadeReady = 'true';

    const update = () => {
        const hasOverflow = scroller.scrollWidth > scroller.clientWidth + 2;
        const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
        list.classList.toggle('has-more-thumbs', hasOverflow && !atEnd);
    };

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    scroller.closest('product-gallery')?.addEventListener('carousel:filter', () => requestAnimationFrame(update));
    requestAnimationFrame(update);
};

document.addEventListener('DOMContentLoaded', () => {
    preorderFieldValidation();
    additionalCheckoutValidation();
    watchesReviewsSlider();
    releaseGalleryWheelScroll();
    setupThumbnailSliderFade();
    setTimeout(() => {
        appFieldValidation();
    },1000)
})

document.addEventListener('cart:change', function (event) {
    setTimeout(() => {
        preorderFieldValidation();
    },1000)
});
